<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="undefined"
    ref="sell-price-product"
    :data-model="dataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    class="sell-price-product"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  PricingTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/pricing-tabs";
import { SellPriceProductService } from "../../_services/api/sales/sell-price-product.service";
import { authComputed } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      dataModel: {},
      reload: false,
      validationSummary: [],
      serverError: {},
      sellPriceProductItems: [],
      columns: [
        {
          screenField: "Product",
          allowHiding: false,
          fixed: true,
          fixedPosition: "left",
          // label: "Product / Account",
          width: "auto",
          sortOrder: "asc",
          sortIndex: 0,
          cssClass: "header-text-align",
        },
        {
          screenField: "SalesUM",
          dataField: "SalesUM",
          fixed: true,
          fixedPosition: "left",
          minWidth: 25,
          cssClass: "header-text-align",
        },
        {
          screenField: "Ordered",
          fixed: true,
          fixedPosition: "left",
          dataField: "LastCost",
          width: 110,
          minWidth: 110,
          label: "Last Cost",
          cssClass: "header-text-align",
        },
        {
          screenField: "ProductCategory1",
          filterLabel: "Category 1",
          filterIndex: 0,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory2",
          filterLabel: "Category 2",
          filterIndex: 1,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory3",
          filterLabel: "Category 3",
          filterIndex: 2,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory4",
          filterLabel: "Category 4",
          filterIndex: 3,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductType",
          filterLabel: "Type",
          filterIndex: 4,
          showInColumnChooser: false,
          visible: false,
        },

        // {
        //   screenField: "Comments",
        //   dataField: "Comment",
        //   width: 400,
        //   minWidth: 400,
        //   cellTemplate: "ScrollView",
        //   cssClass: "grid-text-scroll",
        //   label: "PO Comments",
        //   allowEditing: false,
        // },
      ],
    };
  },

  async created() {
    this.setLoading = true;
  },
  async mounted() {
    // await this.$store.dispatch(
    //   "defaultCustomerSettings/setCustomerById",
    //   this.baseView.id
    // );
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...authComputed,
    getScreenJson() {
      var screenJson = {
        title: "Goods In",
        endpoint: {
          // primary: "CashReceipt",
          // expand: "Customer($select=Name)",
          // CodeBy: this.baseView.mode !== "review" ? "text" : undefined,
          // postProcess: this.cashReceiptPostProcess,
        },
        headerData: {
          headerFormVisible: false,
          headerToolbar: {
            audit: false,
            status: false,
            notes: false,
            save: false,
            // saveCallback: this.saveSellPriceProduct,
          },
          // formItems: [
          //   {
          //     itemType: "group",
          //     caption: "",
          //     colCount: 3,
          //     items: [
          //       {
          //         itemType: "group",
          //         caption: "",
          //         items: [
          //           {
          //             screenField: "DateIn",
          //           },
          //           {
          //             dataField: "PayMethod",
          //             label: {
          //               text: "Payment Method",
          //             },
          //           },
          //           {
          //             dataField: "BankAccount",
          //             label: {
          //               text: "Bank Acc",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          // ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Pricing",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          selectedIndex: GetIndexByTabName("Sell Price by Product"),
          tabs: PricingTabs,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              // postProcessCallback: this.PostProcess,

              localDataList: true,
              items: this.sellPriceProductItems,
            },
            options: {
              keyboardNavigation: {
                enabled: true,
                key: "ID",
              },
              focusedRowEnabled: true,
              showColumnLines: true,
              repaintChangesOnly: true,
              // wordWrapEnabled: false,
              // selectionMode: 'none'
            },
            // noDataMessage: {
            //   // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
            //   review: {
            //     addNew: {
            //       class: "no-data",
            //       title: "No Credit Lines",
            //       message: "Get Started, Add a Credit Line",
            //     },
            //   },
            // },
          },
          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            review: false,
            save: true,
            saveMenu: {
              items: [{ text: "Save" }, { text: "Save & Recalculate" }],
              keyExpr: "text",
              displayExpr: "text",
              dropDownOptions: {
                width: "170px",
              },
              icon: "floppy",
            },
            saveCallback: this.saveSellPriceProduct,
            // form: {
            //   location: "left",
            //   items: [
            //     {
            //       dataField: "DateIn",
            //       label: "Date In",
            //       editorType: "dxDateBox",
            //       editorOptions: {
            //         displayFormat: "dd MMM yyyy",
            //         width: 120,
            //       },
            //       validationRules: [
            //         {
            //           type: "required",
            //           message: "Date In is required",
            //         },
            //       ],
            //     },
            //     {
            //       dataField: "DateReceived",
            //       label: "Date Received",
            //       editorType: "dxDateBox",
            //       editorOptions: {
            //         displayFormat: "dd MMM yyyy",
            //         width: 120,
            //       },
            //       validationRules: [
            //         {
            //           type: "required",
            //           message: "Date Received is required",
            //         },
            //       ],
            //     },
            //   ],
            // },
          },

          // childColumns: [
          //   {
          //     screenField: "Batch",
          //     gridDataField: "BatchNo",
          //     allowEditing: false,
          //     showEditorAlways: false,
          //     cellTemplate: "EditableText",
          //   },
          //   {
          //     screenField: "SupplierBatchNo",
          //     cellTemplate: "EditableText",
          //   },
          //   {
          //     screenField: "UseByDate",
          //     allowEditing: false,
          //     allowSearch: false,
          //     allowFiltering: false,
          //     cellTemplate: "Date",
          //     editable: true,
          //   },
          //   {
          //     screenField: "Quantity",
          //     dataField: "SupplierBatchReceivedQty",
          //     type: "EditableDecimal",
          //     showEditorAlways: true,
          //     format: "Decimal-16-2",
          //   },
          //   {
          //     dataField: "ActionDelete",
          //     label: "",
          //     width: 50,
          //     minWidth: 50,
          //     cellTemplate: "ActionDelete",
          //   },
          //   {
          //     dataField: "ActionAddNew",
          //     label: "",
          //     width: 50,
          //     minWidth: 50,
          //     cellTemplate: "ActionAddNew",
          //   },
          // ],
          columns: this.getColumns,
          valueChangedEventListners: [
            //  {
            //   dataField: "SupplierReceivedQty",
            //   listner: (e, lineData) => {
            //     if (e.value > 0) lineData.data.CheckInclude = true;
            //     else lineData.data.CheckInclude = false;
            //     var gridItems = lineData.component.getDataSource().items();
            //     this.onSupplierReceivedQtyChange(e, lineData, gridItems);
            //   },
            // },
          ],

          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "GoodsInComment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      maxLength: 100,
                      height: 70,
                    },
                  },
                ],
              },
            ],
          },
        },
        // footerData: {
        //   footerItems: [
        //     {
        //       screenField: "Quantity",
        //       dataField: "SupplierReceivedQty",
        //       location: "left",
        //       label: "Item Count",
        //       value: 0,
        //       format: "Decimal-16-0",
        //     },
        //   ],
        // },
      };
      return screenJson;
    },
    getColumns() {
      return this.columns;
    },
  },
  methods: {
    async initialized() {
      var productItems = [];
      await SellPriceProductService.getPriceGroupRRPProductList()
        .then((res) => {
          if (res.data.value.length > 0) productItems = res.data.value;
        })
        .catch((err) => {
          this.loaded = true;
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Request Failed",
            time: new Date().getTime(),
          };
        });

      if (productItems.length > 0) {
        var maxLength = Math.max(
          ...productItems.map((item) => item.PriceGroupRRPProductGroups.length)
        );
        var maxLengthItemIndex = productItems.findIndex(
          (x) => x.PriceGroupRRPProductGroups.length == maxLength
        );

        await productItems.forEach(async (element) => {
          element.ID = element.ProductCode + "-" + element.SalesUM;
          if (element.PriceGroupRRPProductGroups.length != maxLength) {
            var undefinedItems = [];
            productItems[maxLengthItemIndex].PriceGroupRRPProductGroups.forEach(
              (item) => {
                var i = element.PriceGroupRRPProductGroups.findIndex(
                  (x) => x.PriceGroupID == item.PriceGroupID
                );
                if (i == -1) undefinedItems.push(item.PriceGroupID);
              }
            );

            for (let index = 0; index < undefinedItems.length; index++) {
              element.PriceGroupRRPProductGroups.push({
                PriceGroupID: undefinedItems[index],
                PriceGroupName:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].PriceGroupName,
                PriceGroupDescription:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].PriceGroupDescription,
                CustomerGroup2Code:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].CustomerGroup2Code,
                CustomerGroup2Description:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].CustomerGroup2Description,
                ProductCode:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].ProductCode,
                SalesUM: element.SalesUM,
                LastCost: element.LastCost,
                SellPrice: null,
                RRP: null,
                SellGrossProfitPcnt: 0,
                RRPGrossProfitPcnt: 0.0,
                ConversionFactor:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].ConversionFactor,
                RRPConversionFactor:
                  productItems[maxLengthItemIndex].PriceGroupRRPProductGroups[
                    index
                  ].RRPConversionFactor,
              });
            }

            element.PriceGroupRRPProductGroups.sort(function (a, b) {
              return a.PriceGroupID - b.PriceGroupID;
            });
          }

          await element.PriceGroupRRPProductGroups.forEach((item) => {
            // if(item.SellPrice == 0) item.SellPrice = undefined;
            // if(item.RRP == 0) item.RRP = undefined;
            if (item.SellPrice || item.RRP) item.IsOrigin = true;
          });

          // if (element.ProductCode == "CON10PETPOUCH") {
          //   element.PriceGroupRRPProductGroups.forEach((item) => {
          //     if (item.PriceGroupID == 23) {
          //       console.log("XXX ", item.SalesUM, ">>>mic", item);
          //     }
          //   });
          // }
        });

        await productItems[
          maxLengthItemIndex
        ].PriceGroupRRPProductGroups.forEach((element, index) => {
          this.columns.push({
            dataField: `PriceGroupRRPProductGroups[${index}].CustomerGroup2Code`,
            label: element.PriceGroupDescription,
            alignment: "center",
            columns: [
              {
                dataField: `PriceGroupRRPProductGroups[${index}].SellPrice`,
                label: "Sell",
                width: 100,
                minWidth: 100,
                type: "EditableDecimal",
                format: "Decimal-16-2",
                showEditorAlways: true,
                allowUpdate: true,
                allowEditing: true,
                makeReadOnly: () => {
                  return false;
                },
                valueChangeCallBack: this.onSellValueChange,
                dataPath: ["PriceGroupRRPProductGroups", index, "SellPrice"],
                editorOptions: {
                  keyUp: (e, lineData) => {
                    if (
                      e.event &&
                      (e.event.key == "Backspace" || e.event.keyCode == 8)
                    ) {
                      // if (
                      //   !lineData.data[lineData.column.dataPath[0]][
                      //     lineData.column.dataPath[1]
                      //   ].IsOrigin
                      // )
                      this.onSellValueChange({ value: undefined }, lineData);
                    }
                  },
                },
              },
              {
                dataField: `PriceGroupRRPProductGroups[${index}].RRP`,
                label: "RRP",
                width: 100,
                minWidth: 100,
                type: "EditableDecimal",
                format: "Decimal-16-2",
                showEditorAlways: true,
                allowUpdate: true,
                allowEditing: true,
                makeReadOnly: () => {
                  return false;
                },
                valueChangeCallBack: this.onSellValueChange,
                dataPath: ["PriceGroupRRPProductGroups", index, "RRP"],
                editorOptions: {
                  keyUp: (e, lineData) => {
                    if (
                      e.event &&
                      (e.event.key == "Backspace" || e.event.keyCode == 8)
                    ) {
                      // if (
                      //   !lineData.data[lineData.column.dataPath[0]][
                      //     lineData.column.dataPath[1]
                      //   ].IsOrigin
                      // )
                      this.onSellValueChange({ value: undefined }, lineData);
                    }
                  },
                },
              },
              {
                dataField: `PriceGroupRRPProductGroups[${index}].SellGrossProfitPcnt`,
                screenField: "Quantity",
                label: "Sell GP%",
                format: "Decimal-16-2",
                width: 100,
                minWidth: 100,
              },
              {
                dataField: `PriceGroupRRPProductGroups[${index}].RRPGrossProfitPcnt`,
                screenField: "Quantity",
                label: "RRP GP%",
                width: 100,
                minWidth: 100,
                format: "Decimal-16-2",
              },
            ],
          });
        });

        // await SellPriceProductService.getPriceGroupRRPProductGroupList().then(
        //   (res) => {
        //     groupItems = res.data.value;
        //   }
        // );
      }

      this.sellPriceProductItems = productItems;
      this.loaded = true;
      this.setLoading = false;
    },
    onSellValueChange(e, lineData) {
      lineData.data[lineData.column.dataPath[0]][lineData.column.dataPath[1]][
        lineData.column.dataPath[2]
      ] = e.value;

      var data =
        lineData.data[lineData.column.dataPath[0]][lineData.column.dataPath[1]];

      if (data.SellPrice == 0 || !data.SellPrice)
        data["SellGrossProfitPcnt"] = 0;
      else
        data["SellGrossProfitPcnt"] =
          ((data.SellPrice - lineData.data.LastCost * data.ConversionFactor) /
            data.SellPrice) *
          100;

      if (data.RRP == 0 || !data.RRP) data["RRPGrossProfitPcnt"] = 0;
      else
        data["RRPGrossProfitPcnt"] =
          ((data.RRP - data.SellPrice / data.RRPConversionFactor) / data.RRP) *
          100;
    },
    async saveSellPriceProduct(dataModel, gridItems, extra) {
      this.setLoading = true;
      // eslint-disable-next-line no-console
      // console.log("saveSellPriceProduct ", extra);

      var item =
        this.$refs[
          "sell-price-product"
        ].$refs.transactionGrid.getDataSourceInstance();

      // since the data-source is local
      gridItems = [...item.getDataSource().store()._array];

      var payload = {
        Username: this.currentUser,
        RecalculateSalesOrderPrice: extra.text == "Save" ? "false" : "true",
        Code: "00000",
        PriceGroupRRPProductList: this.getPriceGroupRRPProductList(gridItems),
      };

      await SellPriceProductService.saveSellPriceProduct(payload)
        .then((res) => {
          if (res) this.setLoading = false;
          this.$notify(`Save successfully completed`, "Success");
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "save failed",
            time: new Date().getTime(),
          };
        });
    },
    getPriceGroupRRPProductList(gridItems) {
      var dataItems = [];

      gridItems.forEach((element) => {
        var obj = {
          LastCost: element.LastCost,
          ProductCode: element.ProductCode,
          ProductDescription1: element.ProductDescription1,
          ProductDescription2: element.ProductDescription2,
          SalesUM: element.SalesUM,
          PriceGroupRRPProductGroups: [],
        };

        element.PriceGroupRRPProductGroups.forEach((item) => {
          if (item.RRP != null || item.SellPrice != null || item.IsOrigin) {
            if (item.SellPrice == undefined) item.SellPrice = null;
            if (item.RRP == undefined) item.RRP = null;
            delete item.IsOrigin;
            obj.PriceGroupRRPProductGroups.push(item);
          }
        });

        if (obj.PriceGroupRRPProductGroups.length > 0) dataItems.push(obj);
      });

      return dataItems;
    },
  },
};
</script>

<style lang="scss">
.sell-price-product {
  td[role="columnheader"].header-text-align {
    vertical-align: bottom !important;
  }

  .dx-datagrid .dx-column-lines > td {
    border-left: 1px solid #e0e0e0 !important;
    border-right: 1px solid #e0e0e0 !important;
  }
  .dx-datagrid .dx-row-lines > td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
}
</style>
